class SettingsApi {
  static update(body: any) {
    return true;
  }
}

export default SettingsApi;
